import { Link, useNavigate } from "react-router-dom";
import styles from "./styles/style.module.css";
import { useState } from "react";
import apiEndPoint from "../../services/apiService/apiEndPoints";
import { postApi } from "../../services/apiService/fetchMethod";
import tostMessage from "../../utils/tostMessage";
import encrypt from "../../services/hash-service/encrypt-service";
import SiginAndSignUpWrapper from "../../components/SigninAndSignup/SiginAndSignUpWrapper";
import Loader from "../../commonComponents/loader/Loader";
import LoaderCircle from "../../commonComponents/loader/LoaderCircle";
import InputField from "../../commonComponents/InputField/InputField";
function SignIn() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [step, setStep] = useState(0);
  const [userData, setUserData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingOtp, setLoadingOtp] = useState(false);
  const [otp, setOtp] = useState(new Array(6).fill(""));
  const handleSubmit = async (e) => {
    setLoading(true);
    e.preventDefault();
    let url = apiEndPoint().SIGNIN;
    let params = {
      email,
      password,
      pratham:true
    };
    if (Number(email)) {
      params = {
        phone: email,
        password,
        pratham:true
      };
    }
    const { status, data } = await postApi({ url, params });
    console.log(data);
    setUserData(data.data);
    tostMessage(status, data.message);
    if (status === 200) {
      if (!data.data?.accessToken || !data.data?.refreshToken) {
        setStep(1);
      } else {
        localStorage.setItem("Token", data?.data?.accessToken);
        localStorage.setItem(
          "User",
          encrypt(
            JSON.stringify({
              firstName: data?.data?.firstName,
              lastName: data?.data?.lastName,
              email: data?.data?.email,
              profile_img: data?.data?.profile_img,
              projects: data?.data?.projects?.map((item) => ({
                value: item._id,
                label: item.project_name,
              })),
            })
          )
        );
        if (data?.data?.selectedProject) {
          localStorage.setItem(
            "selectedProject",
            encrypt(JSON.stringify(data?.data?.selectedProject))
          );
        }
        if (data?.data?.modules) {
          localStorage.setItem(
            "modules",
            encrypt(JSON.stringify(data?.data?.modules))
          );
        }
        navigate("/auth/workspace");
      }
    }
    setLoading(false);
  };

  const handleSubmitOtp = async (e, otpVal) => {
    if (e) {
      e.preventDefault();
    }
    setLoading(true);
    let url = apiEndPoint().VIRIFY_OTP;
    let params = {
      otp: otpVal ? otpVal : otp,
      hash: userData.hash,
      phone: userData.phone,
    };
    const { status, data } = await postApi({ url, params });
    console.log(data, status);
    if (status === 200) {
      localStorage.setItem("Token", data?.data?.accessToken);
      localStorage.setItem(
        "User",
        encrypt(
          JSON.stringify({
            firstName: data?.data?.firstName,
            lastName: data?.data?.lastName,
            email: data?.data?.email,
            profile_img: data?.data?.profile_img,
            projects: data?.data?.projects?.map((item) => ({
              value: item._id,
              label: item.project_name,
            })),
          })
        )
      );
      if (data?.data?.selectedProject) {
        localStorage.setItem(
          "selectedProject",
          encrypt(JSON.stringify(data?.data?.selectedProject))
        );
      }
      if (data?.data?.modules) {
        localStorage.setItem(
          "modules",
          encrypt(JSON.stringify(data?.data?.modules))
        );
      }
      navigate("/auth");
    }
    tostMessage(status, data.message);
    setLoading(false);
    setOtp("");
  };

  const handleEnter = (element) => {
    if (isNaN(element.target.value)) return false;
    setOtp(element.target.value);
    if (element.target.value.toString().length === 6) {
      handleSubmitOtp(false, element.target.value);
    }
  };

  const resendOtp = async () => {
    setLoadingOtp(true);
    let url = apiEndPoint().SEND_OTP;
    let { data, status } = await postApi({
      url,
      params: { phone: userData?.phone },
    });
    tostMessage(status, data.message);
    setUserData(data.data);
    setLoadingOtp(false);
  };

  let emailData = userData?.email?.split("@");

  return (
    <SiginAndSignUpWrapper
      title="Log in"
      step={step}
      setStep={setStep}
      setUserData={setUserData}
    >
      {step === 1 ? (
        <form onSubmit={handleSubmitOtp}>
          <h3 style={{ marginBlock: "1.5rem" }}>
            Otp sent on {userData?.phone[0]}
            {userData?.phone[1]}xxxxxx{userData?.phone[8]}
            {userData?.phone[9]} & {emailData && emailData[0][0]}
            {emailData && emailData[0][1]}xxxx@{emailData && emailData[1]}
          </h3>
          <div className={styles.otpBox}>
            <input
              className={styles.otpInput}
              type="number"
              name="otp"
              placeholder="Enter 6 digit OTP"
              value={otp}
              onChange={handleEnter}
              required={true}
            />
          </div>
          <button
            className={styles.loginBtn}
            style={{ width: "100%", padding: loading ? "0.28rem" : "1rem" }}
            type="submit"
          >
            {loading ? <Loader /> : "Verify OTP"}
          </button>
          <div
            className={styles.formBox}
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginBlock: "0.7rem",
            }}
          >
            <div
              className={styles.forgetText}
              onClick={resendOtp}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              Resend Otp {loadingOtp && <LoaderCircle size={20} />}
            </div>
            <div className={styles.forgetText} onClick={() => setStep(0)}>
              Go to Login
            </div>
          </div>
        </form>
      ) : (
        <form onSubmit={handleSubmit}>
          <div className={styles.formBox}>
            <InputField
              placeholder="Email or Phone"
              type="text"
              required={true}
              seterVal={setEmail}
              gaterVal={email}
            />
          </div>
          <div className={styles.formBox} style={{ marginBottom: "1rem" }}>
            <InputField
              placeholder="Password"
              type="password"
              required={true}
              seterVal={setPassword}
              gaterVal={password}
            />
          </div>
          <div
            className={styles.formBox}
            style={{ display: "flex", justifyContent: "end" }}
          >
            <Link to="/forget-password" className={styles.forgetText} style={{fontSize:"14px",fontWeight:"600"}}>
              Forgot your password
            </Link>
          </div>

          <button
            className={styles.loginBtn}
            style={{ width: "100%", padding: loading ? "0.28rem" : "1rem" }}
            type="submit"
          >
            {loading ? <Loader /> : "Log in"}
          </button>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginTop: "1rem",
            }}
          >
            <Link
              to="/signup"
              className={styles.forgetText}
              style={{ fontSize: "14px", fontWeight: "500" }}
            >
              Create New Account
            </Link>
          </div>
        </form>
      )}
    </SiginAndSignUpWrapper>
  );
}

export default SignIn;
